// authDuck.js
import jwt_decode from 'jwt-decode';
import axios from "axios";
import setAuthorizationToken, { setRefreshToken, setUserId, setCompanyInfo, setIdentityId, setGroupInfo } from '../utils/setAuthorizationToken';
import { authEndpoints } from "../api/endpoints";
import Duck from 'extensible-duck';
import Users from "./Users";


const UsersActions = Users.creators;

export default new Duck({
  namespace: 'AuxoAuth', store: 'userAuthentication',
  types: ['USER_IS_LOADING', 'USER_AUTHENTICATED', 'USER_SET', 'THINGS_ASSIGNED', 'GROUP_LOGIN'],
  initialState: {
    user: {},
    loggedInGroupInfo: localStorage.getItem("groupInfo") ? JSON.parse(localStorage.getItem("groupInfo")) : {},
    isLoading: false,
    isAuthenticated: false,
    thingsAssigned: true
  },
  reducer: (state, action, duck) => {

    switch (action.type) {
      case duck.types.USER_IS_LOADING:
        return {
          ...state,
          isLoading: action.isLoading
        };
      case duck.types.USER_AUTHENTICATED:
        return {
          ...state,
          isAuthenticated: action.isAuthenticated
        };
      case duck.types.USER_SET:
        return {
          ...state,
          user: action.user
        };
      case duck.types.USER_SET_PERMISSIONS:
        return {
          ...state,
          permissions: action.permissions
        };
      case duck.types.THINGS_ASSIGNED:
        return {
          ...state,
          thingsAssigned: action.thingsAssigned
        };
      case duck.types.GROUP_LOGIN:
        return {
          ...state,
          loggedInGroupInfo: action.group
        };
      default:
        return state;
    }
  },
  selectors: {
    root: state => state
  },
  creators: (duck) => ({
    updateLoggedInGroupInfo: state => async (dispatch, getState) => {
      const groupData = state;
      dispatch({ type: duck.types.GROUP_LOGIN, group: groupData });
      setGroupInfo(groupData);
    },

    setAdminUser: (userInfo) => async (dispatch, getState) => {
      const refreshToken = userInfo.refreshToken;
      const token = userInfo.token;
      const identityId = userInfo.identityId;
      const userId = userInfo.userId;
      const info = userInfo.companyInfo;
      localStorage.setItem("isSuperAdminUser", {isSuperAdminUser: true});
      const groupData = userInfo.groupData;
      dispatch({ type: duck.types.GROUP_LOGIN, group: groupData });

      setAuthorizationToken(token);
      setIdentityId(identityId);
      setRefreshToken(refreshToken);

      let user = jwt_decode(token);

      dispatch({ type: duck.types.USER_AUTHENTICATED, isAuthenticated: true });
      dispatch({ type: duck.types.USER_SET, user });
      dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });

      await setUserId(userId);
      setCompanyInfo(info);
      setGroupInfo(groupData);


      // dispatch(UsersActions.getUserNotificationsSetting());
      dispatch(UsersActions.subscribeNotifications());
    },
    loginUser: state => async (dispatch, getState) => {
      if (getState().userAuthentication.isLoading) {
        // Don't issue a duplicate request (we already have or are loading the requested data)
        return;
      }
      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });

        const response = await axios.post(authEndpoints.login, { username: state.username, password: state.password});
        const refreshToken = response.data.access_token;
        const token = response.data.access_token;
        const userId = response.data.user._id;
        const info = {
          groupId: response.data.user.groupId,
          companyId: response.data.user.companyId,
        }

        dispatch({ type: duck.types.USER_AUTHENTICATED, isAuthenticated: true });
        dispatch({ type: duck.types.USER_SET, user:response.data.user });
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        localStorage.setItem('user',JSON.stringify(response.data));
        setCompanyInfo(info);
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    forgotPassword: email => async (dispatch, getState) => {
      if (getState().userAuthentication.isLoading) {
        // Don't issue a duplicate request (we already have or are loading the requested data)
        return;
      }
      try {

        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });
        await axios.post(authEndpoints.forgotPassword, { email });
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    confirmCode: state => async (dispatch, getState) => {
      if (getState().userAuthentication.isLoading) {
        // Don't issue a duplicate request (we already have or are loading the requested data)
        return;
      }
      try {

        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });
        let response = await axios.post(authEndpoints.verification(state.token), {password : state.password});
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        return response.data;
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    getUserByToken: state => async (dispatch, getState) => {
      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });

        let response = await axios.post(authEndpoints.getUserByToken(state.token));
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        return response.data;
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    checkLinkValidity: state => async (dispatch, getState) => {
      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });

        console.log("STATE>TOKEN: ", state.token);
        let response = await axios.post(authEndpoints.checkLinkValidity(state.token));
        console.log("RESPONE: ", response);
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        return response.data;
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },

    resetPassword: state => async (dispatch, getState) => {
      if (getState().userAuthentication.isLoading) {
        // Don't issue a duplicate request (we already have or are loading the requested data)
        return;
      }
      try {

        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });
        let response  = await axios.post(authEndpoints.setforget(state.id,state.token), {password : state.password});
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        return response.data;
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },

    refreshToken: state => async (dispatch, getState) => {

      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });
        await axios.get(authEndpoints.refreshToken);
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    },
    logoutUser: () => async (dispatch, getState) => {

      localStorage.clear();
      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });

      }
      catch (e) {
        throw e;
      }
    },
    setUser: user => async (dispatch, getState) => {
      dispatch({ type: duck.types.USER_SET, user });
      dispatch({ type: duck.types.USER_AUTHENTICATED, isAuthenticated: true });
    },
    confirmUser: state => async (dispatch, getState) => {
      try {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: true });
        await axios.post(authEndpoints.confirmUser, state);
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
      }
      catch (e) {
        dispatch({ type: duck.types.USER_IS_LOADING, isLoading: false });
        throw e;
      }
    }

  })
})